export const DIVISION_EXCLUSION_ZONE_PROPERTY_TYPE =
  "park-division-exclusion-zone";
export const DIVISION_INCLUSION_ZONE_PROPERTY_TYPE =
  "park-division-inclusion-zone";
